import { configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import rootReducer from "./store/rootReducer";


const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

/* if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./store/reducers", () => {
    const newRootReducer = require("./store/reducers").default;
    store.replaceReducer(newRootReducer);
  });
} */

export type AppDispatch = typeof store.dispatch;
export default store;
